import axios from 'axios';
const isRecord = (value) => typeof value === 'object' && value !== null;
const toText = (value) => {
    if (typeof value === 'string') {
        const trimmed = value.trim();
        return trimmed || undefined;
    }
    if (typeof value === 'number' || typeof value === 'boolean') {
        return String(value);
    }
    return undefined;
};
const joinMessages = (values, separator) => {
    const messages = values.filter((value) => Boolean(value));
    if (messages.length === 0) {
        return undefined;
    }
    return messages.join(separator);
};
const resolveRecordEntriesMessage = (value) => {
    const entries = Object.entries(value)
        .map(([key, item]) => {
        const message = resolvePayloadMessage(item);
        if (!message) {
            return undefined;
        }
        return `${key}: ${message}`;
    })
        .filter((item) => Boolean(item));
    if (entries.length === 0) {
        return undefined;
    }
    return entries.join(' / ');
};
const resolvePayloadMessage = (value) => {
    const text = toText(value);
    if (text) {
        return text;
    }
    if (Array.isArray(value)) {
        return joinMessages(value.map((item) => resolvePayloadMessage(item)), ', ');
    }
    if (!isRecord(value)) {
        return undefined;
    }
    const preferredKeys = ['message', 'detail', 'error', 'details', 'reason'];
    for (const key of preferredKeys) {
        const resolved = resolvePayloadMessage(value[key]);
        if (resolved) {
            return resolved;
        }
    }
    if ('errors' in value) {
        const errors = value.errors;
        if (isRecord(errors)) {
            const errorsMessage = resolveRecordEntriesMessage(errors);
            if (errorsMessage) {
                return errorsMessage;
            }
        }
        else {
            const errorsMessage = resolvePayloadMessage(errors);
            if (errorsMessage) {
                return errorsMessage;
            }
        }
    }
    const entryMessage = resolveRecordEntriesMessage(value);
    if (entryMessage) {
        return entryMessage;
    }
    try {
        const serialized = JSON.stringify(value);
        if (serialized && serialized !== '{}') {
            return serialized;
        }
    }
    catch {
        return undefined;
    }
    return undefined;
};
export const resolveRequestErrorMessage = (error, fallback) => {
    var _a, _b;
    if (axios.isAxiosError(error)) {
        const responseMessage = resolvePayloadMessage((_a = error.response) === null || _a === void 0 ? void 0 : _a.data);
        if (responseMessage) {
            return responseMessage;
        }
        const axiosMessage = toText(error.message);
        if (axiosMessage) {
            return axiosMessage;
        }
    }
    if (isRecord(error)) {
        const message = resolvePayloadMessage(error.message);
        if (message) {
            return message;
        }
    }
    return (_b = toText(error)) !== null && _b !== void 0 ? _b : fallback;
};
